// Asume que la URL base de tu API podría cambiar o ser reutilizada, por lo que podría ser buena idea definirla como constante.
export const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/Users`;

/**
 * Obtiene los datos de Users para un ID específico.
 * @param {string} id - El ID del registro Users que se desea obtener.
 * @returns {Promise<any>} - Los datos de Users obtenidos.
 */
export const fetchUsersData = async (id) => {
  const api_key = localStorage.getItem("access_token") || "";
  try {
    const response = await fetch(`${BASE_URL}/${id}`, {
      method: "GET",
      headers: {
        authToken: api_key,
      },
    });
    if (!response.ok) {
      throw new Error("Error al obtener los datos de Users");
    }
    return await response.json();
  } catch (error) {
    console.error("Error al obtener datos de Users:", error);
    throw error; // Propagar el error para manejarlo en el componente.
  }
};

/**
 * Envía los datos modificados de Users al servidor.
 * @param {Object} UsersData - Los datos modificados de Users a guardar.
 * @returns {Promise<void>}
 */
export const saveUsersData = async (UsersData) => {
  const api_key = localStorage.getItem("access_token") || "";
  var response = null;
  try {
    response = await fetch(`${BASE_URL}`, {
      method: "POST", // Cambiar a "PUT" si tu API usa PUT para actualizaciones.
      headers: {
        "Content-Type": "application/json",
        authToken: api_key,
      },
      body: JSON.stringify({
        ...UsersData,
      }),
    });

    // Opcional: Procesar la respuesta si es necesario.
  } catch (error) {
    throw error; // Propagar el error para manejarlo en el componente.
  }
  return response;
};
